/**
 * @file Test mode and sign-out, shared by the profile menu (standalone) and
 * Settings → Session (where they live inside the IT Hub, which hides the
 * profile block).
 */

import { collection, getDocs, limit, query } from 'firebase/firestore';

import { db } from './firebase.js';
import { signOutCurrent } from './auth.js';
import { redirect } from './router.js';
import { seedTestData } from './api.js';
import { clearSearchIndex } from './search.js';
import { isTestMode, setTestMode } from './test-mode.js';

/**
 * Flip test mode. The sandbox is SHARED and usually already populated —
 * entering just flips the flag. Only when the shared data is missing
 * entirely (first ever use / after a reset) does entry seed it, so flipping
 * test mode is instant and never stomps a colleague's test session.
 * setTestMode re-mounts the whole app.
 */
export async function toggleTestMode() {
  if (isTestMode()) { setTestMode(false); return; }
  const probe = await getDocs(query(collection(db, 'test_employees'), limit(1)));
  if (probe.empty) await seedTestData();
  setTestMode(true);
}

export async function signOutHere() {
  clearSearchIndex();
  await signOutCurrent();
  redirect('/');
}
